
















































































import {Component, Vue, Watch} from 'vue-property-decorator';
import {Action, Getter, Mutation} from "vuex-class";
import featureFlags from "@/util/featureFlags";
import LoadingButton from "@/components/LoadingButton.vue";
import AnimatedInput from "@/components/AnimatedInput.vue";
import {Modal} from "bootstrap-vue";
import messageBus from "@/util/messageBus";
import PersistentLogin from "@/util/persistentLogin";
//@ts-ignore
import { throttle, debounce } from 'throttle-debounce';

@Component({
  components: {AnimatedInput, LoadingButton},
})
export default class App extends Vue {

  @Getter isLoggedIn!: boolean;
  @Getter isAdmin!: boolean;
  @Mutation logout!: () => void;
  @Action login!: ({username, password, persistent}: {username: string, password: string, persistent: boolean}) => Promise<any>;

  loginName: string = "";
  loginPassword: string = "";
  loginPersistent: boolean = true;

  loginIsLoading: boolean = false;

  loginMessage: string = "";

  get hasLogin() {
    return featureFlags.usersEnabled;
  }

  get requiresLogin() {
    return featureFlags.enforceLogin;
  }

  get showPresentedBy(): boolean {
    return featureFlags.showPresentedBy;
  }

  get presentedByLogoUrl(): string {
    return featureFlags.presentedByLogoAddress;
  }

  get presentedByLogoClickUrl(): string {
    return featureFlags.presentedByLogoClickUrl;
  }

  get targetRoute(): string | null {
    // tslint:disable-next-line
    if (this.$route.query.hasOwnProperty('loginandgoto')) {
      // tslint:disable-next-line
      if(Array.isArray(this.$route.query['loginandgoto'])) {
        // tslint:disable-next-line
        return this.$route.query['loginandgoto'][0];
      } else {
        // tslint:disable-next-line
        return this.$route.query['loginandgoto'] as string;
      }

    } else {
      return null;
    }
  }

  doLogout() {
    this.logout();
    this.$router.push('/?loginandgoto=' + "/");
  }

  openLoginModal() {
    (this.$refs.loginmodal as Modal).show();
  }

  closeLoginModal() {
    (this.$refs.loginmodal as Modal).hide();
    this.loginMessage = "";
  }

  resetLoginModal() {
    this.$nextTick(() => {
      this.loginName = "";
      this.loginPassword = "";
      this.loginPersistent = true;
      this.loginIsLoading = true;
    });
  }

  async doLogin() {
    try {
      this.loginIsLoading = true;
      this.$log.debug(`Login called with ${this.loginName} and ${this.loginPassword}`);
      await this.login({username: this.loginName.trim(), password: this.loginPassword.trim(), persistent: this.loginPersistent});
      if (this.targetRoute || this.$route.path === "/") { //if on index or a target is specified, redirect!
        this.$router.push(this.targetRoute ? this.targetRoute : '/account');
      }
    } catch (e) {
      this.$toast.clear();
      this.$toast.error("Login failed, try again");
    } finally {
      this.closeLoginModal();
      this.resetLoginModal();
    }
  }

  @Watch('$route')
  watchRouteForParamChanges() {
    if (this.targetRoute) {
      this.$nextTick(() => {
        this.openLoginModal();
      });
    }
  }

  mounted() {
    if (this.targetRoute) {
      this.$nextTick(() => {
        this.openLoginModal();
      });
    }

    messageBus.$on('auth-interactive-needed', (message: string) => {
      if (message) {
        this.loginMessage = message;
      }
      this.openLoginModal();
    });

    const showErrorToastThrottled: (toast: string) => void = throttle(1000, false, (toast: string) => {
      Vue.$toast.error(toast);
    });

    messageBus.$on('auth-error', (route: string) => {
      PersistentLogin.deleteInformation();
      showErrorToastThrottled("You need to be logged in to access this page");
      if (route) {
        this.$router.push('/?loginandgoto=' + route);
      } else {
        this.$router.push('/?loginandgoto=' + "/");
      }
    });
  }


  goToProSite() {
    this.closeLoginModal();
    this.$router.push('/pro');
  }

  goToPwReset() {
    this.closeLoginModal();
    this.$router.push('/resetpassword');
  }
}
